module.exports = __webpack_public_path__ + "img/bag-icon.1ebe7e83.svg";